import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function indexCompanies() {
   return client.get('/api/companies?include=all')
      .then(resolveData);
}

export async function fetchCompany({ slug }) {
   return client.get(`/api/companies/${slug}?include=all`)
      .then(resolveData);
}

export async function updateCompany(slug, changes) {
   return client.put(`/api/companies/${slug}?include=all`, changes)
      .then(resolveData);
}

export async function deleteContact(slug, contact_id) {
   return client.delete(`/api/companies/${slug}/contacts/${contact_id}`)
      .then(resolveData);
}

export async function updateContact(slug, contact_id, payload) {
   return client.put(`/api/companies/${slug}/contacts/${contact_id}`, payload)
      .then(resolveData);
}

export async function createContact(slug, payload) {
   return client.post(`/api/companies/${slug}/contacts`, payload)
      .then(resolveData);
}
